<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { BaseIcon } from "@/components";
const logoImgLink = require("../assets/images/logo.png");

export default {
  name: "EmailReturnPage",
  components: { BaseIcon },
  data() {
    return {
      queryString: "",
      logoImg: logoImgLink,
    };
  },
  mounted() {
    this.queryString = location.search.slice(1);
    this.getPurchaseActivatedStatus({ Token: this.queryString });
  },
  methods: {
    ...mapActions(["getPurchaseActivatedStatus"]),
    ...mapMutations(["setPurchaseActivatedStatus"]),
  },
  computed: {
    ...mapGetters(["purchaseActivatedStatus"]),
  },
};
</script>

<template>
  <div>
    <header class="header">
      <div class="header__logo">
        <router-link to="/" class="header__logo-link">
          <img class="img" alt="Logo" :src="logoImg" />
        </router-link>
      </div>
    </header>
    <div class="erp md-text-center">
      <h1
        class="erp__title erp__title__error"
        v-if="purchaseActivatedStatus.error === true"
      >
        <div>
          <base-icon name="error" />
        </div>
        İşlem Başarısız!
        <br />
        <p>
          {{ purchaseActivatedStatus.message }}
        </p>
      </h1>
      <h1 class="erp__title" v-else>
        <div>
          <base-icon name="success" />
        </div>
        İşlem Başarılı
        <br />
        <p>
          Talebi aktifleştirdiniz. Müşteri datayı kullanabilir durumdadır.
          Yanlışlık yaptığınızı düşünüyorsanız lütfen Osmanlı Menkul ile
          iletişime geçiniz.
        </p>
      </h1>
    </div>
  </div>
</template>

<style lang="scss">
.header {
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
  padding: 5px 20px;

  &__logo {
    max-width: 300px;
    padding-bottom: 0px;
    border-radius: 0%;
    &-link {
      display: block;
    }
  }
  &__image {
    img {
      width: 170px;
      height: 42px;
      padding-left: 10px;
    }
  }
  &__link {
    text-decoration: none;
    padding: 12px 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 14px;
    svg {
      margin-right: 16px;
    }
    &-subtitle {
      &-link {
        display: block;
        width: 100%;
        text-decoration: none;
        color: #fff;
        padding: 10px 0px 10px 50px;
        margin-top: 10px;
        &:hover {
          background-color: var(--color-primary-light);
        }
      }
    }
  }
}
.md-text-center {
  text-align: center;
  justify-content: center;
}
.erp {
  padding-top: 70px;
  &__title {
    color: #28a745;
    margin: 20px 0;
    font-size: 24px;
    font-weight: bold;
    &__error {
      font-size: 24px;
      font-weight: bold;
      color: #dc3545;
    }
  }
}
h1,
h2 {
  color: #28a745;
}
p {
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #686871;
}
</style>
